import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0002',
    ecrans: ['00-2'],
    params: ['?enecleint',
             '?indfor']
});
